module.exports = __webpack_public_path__ + "static/9-c30d437f2be77b714a665b2e5771632e.png";